
import { AuthService } from "@/services/Auth";
import { Menu } from "@/model/Menu";
import Vue from "vue";
import { PerfilService } from "@/services/PerfilService";
import { Utilidades } from "@/Util/Utilidades";

export default Vue.extend({
  name: "Menu",
  data() {
    return {
      menus: new Array<Object>() as Array<Menu>,
      menuPrueba: new Array<Menu>(),
      listaMenus: "" as string,
    };
  },
  mounted() {
    this.cargar_menu_perfil();
    this.$root.$on("actualizarMenu", this.cargar_menu_perfil);
  },
  updated() {
    let btn = document.getElementById("btnLogout");
    if (btn) btn.onclick = () => this.logout();

    //eso es para llamar el router link
    let elements = Array.prototype.slice.call(
      document.getElementsByTagName("a")
    );
    elements = elements.filter((x) => x.id.includes("topnav"));

    elements.forEach((x) => {
      let ruta = x.getAttribute("ruta");      
      x.onclick = () => {
        if (this.$route.path != ruta) {
          this.$router.push({ path: ruta });
        }
      };
    });
  },
  beforeDestroy() {
    this.$root.$off("actualizarMenu", this.cargar_menu_perfil);
  },
  methods: {
    async cargar_menu_perfil() {
      
      let id_perfil = AuthService.getUsuario()?.id_perfil_seleccionado;
      
      if (id_perfil) {
        await PerfilService.getMenusAsync(id_perfil)
          .then(async (x) => {
            this.listaMenus = `<ul class="navbar-nav mt-2">${x.data}</ul>`;
          })
          .catch((y) => {
            Utilidades.Message({ message: y.response.data, error: true });
          });
      }
    },

    logout: function () {
      AuthService.logout();
    },
  },
});
